import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
export function HeroVariant82() {
  const {
    t
  } = useLanguage();
  const {
    formattedPrice
  } = usePricing();
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-[var(--bg-primary)]" data-id="element-1039">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full relative z-10" data-id="element-1040">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-8 items-center" data-id="element-1041">
          {/* Left Column: Editorial Typography */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} className="max-w-2xl" data-id="element-1042">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[var(--text-primary)] leading-[1.25] mb-8" data-id="element-1043">
              Создаем{' '}
              <span className="inline-block w-20 h-12 sm:w-24 sm:h-14 mx-2 rounded-full overflow-hidden align-middle" data-id="element-1044">
                <img src="https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=200&q=80" alt="Code" className="w-full h-full object-cover" data-id="element-1045" />
              </span>{' '}
              уникальные сайты для клиентов,{' '}
              <span className="text-[var(--accent)] italic pr-2" data-id="element-1046">
                нужно оплачивать
              </span>
              только за обслуживание{' '}
              <span className="inline-block w-12 h-12 sm:w-14 sm:h-14 mx-2 rounded-full overflow-hidden align-middle border-2 border-[var(--accent)]" data-id="element-1047">
                <img src="https://images.unsplash.com/photo-1573164713988-8665fc963095?auto=format&fit=crop&w=100&q=80" alt="Face" className="w-full h-full object-cover" data-id="element-1048" />
              </span>{' '}
              всего лишь{' '}
              <span className="inline-flex items-center px-4 py-1 bg-[var(--bg-secondary)] border border-[var(--border)] rounded-2xl align-middle shadow-sm mt-2" data-id="element-1049">
                <span className="text-3xl sm:text-4xl font-black" data-id="element-1050">
                  {formattedPrice}
                </span>
                <span className="text-lg sm:text-xl text-[var(--text-secondary)] ml-1" data-id="element-1051">
                  /мес
                </span>
              </span>
            </h1>

            <div className="flex flex-col sm:flex-row gap-4 mt-10" data-id="element-1052">
              <button onClick={scrollToContact} className="inline-flex items-center justify-center px-8 py-4 text-base font-medium rounded-full text-white bg-[var(--text-primary)] hover:bg-gray-800 transition-all duration-300 shadow-lg hover:shadow-xl hover:-translate-y-1" data-id="element-1053">
                {t('hero.cta')}
                <ArrowRight className="ml-2 w-5 h-5" data-id="element-1054" />
              </button>
            </div>
          </motion.div>

          {/* Right Column: Clean Video */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative lg:h-[750px] rounded-[2.5rem] overflow-hidden shadow-2xl" data-id="element-1055">
            <video autoPlay loop muted playsInline className="absolute inset-0 w-full h-full object-cover" data-id="element-1056">
              <source src="https://cdn.coverr.co/videos/coverr-designer-working-on-a-laptop-2622/1080p.mp4" type="video/mp4" data-id="element-1057" />
            </video>
          </motion.div>
        </div>
      </div>
    </section>;
}